module.exports = __webpack_public_path__ + "static/media/fp-logo.35edc01a.svg";